module.exports = __webpack_public_path__ + "img/plan-2-b10.a839cc24.png";